import { render, staticRenderFns } from "./ChangeCoachPassword.vue?vue&type=template&id=3812f93c&scoped=true"
import script from "./ChangeCoachPassword.vue?vue&type=script&lang=js"
export * from "./ChangeCoachPassword.vue?vue&type=script&lang=js"
import style0 from "./ChangeCoachPassword.vue?vue&type=style&index=0&id=3812f93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812f93c",
  null
  
)

export default component.exports